import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ClipboardModule } from 'ngx-clipboard';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { JoyrideModule } from 'ngx-joyride';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { SettingsModule } from './settings/settings.module';
import { AppComponent } from './app.component';
import { UpgradeComponent } from './auth/upgrade/upgrade.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { SidepanelModule } from './shared/components/sidepanel/sidepanel.module';
import { MAT_SELECT_CONFIG, MatSelectConfig, MatSelectModule } from '@angular/material/select';
import { MAT_CHIPS_DEFAULT_OPTIONS } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from '@angular/material/tooltip';
import {
  MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,
  MatProgressSpinnerDefaultOptions,
} from '@angular/material/progress-spinner';
import {
  MAT_PROGRESS_BAR_DEFAULT_OPTIONS,
  MatProgressBarDefaultOptions,
  MatProgressBarModule,
} from '@angular/material/progress-bar';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { MAT_TABS_CONFIG, MatTabsConfig } from '@angular/material/tabs';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';
import { NewSidenavModule } from './shared/components/new-sidenav/new-sidenav.module';
import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS, MatButtonToggleDefaultOptions } from '@angular/material/button-toggle';
import { MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS, MatSlideToggleDefaultOptions } from '@angular/material/slide-toggle';
import { MAT_LIST_CONFIG, MatListConfig } from '@angular/material/list';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';

const spinnerDefaults: MatProgressSpinnerDefaultOptions = {
  diameter: 36,
  strokeWidth: 3,
};

const progressBarDefaults: MatProgressBarDefaultOptions = {
  mode: 'indeterminate',
};

const customTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 0,
  touchendHideDelay: 1500,
  disableTooltipInteractivity: true,
  position: 'above',
};

const dialogDefaultOptions: MatDialogConfig = {
  hasBackdrop: true,
  disableClose: true,
};

const tabsDefaults: MatTabsConfig = {
  animationDuration: '200ms',
  stretchTabs: false,
};

const matButtonToggleDefaultOptions: MatButtonToggleDefaultOptions = {
  hideSingleSelectionIndicator: true,
  hideMultipleSelectionIndicator: true,
};

const matSlideToggleDefaultOptions: MatSlideToggleDefaultOptions = {
  hideIcon: true,
};

const matSelectConfig: MatSelectConfig = {
  hideSingleSelectionIndicator: true,
};

const matListConfig: MatListConfig = {
  hideSingleSelectionIndicator: true,
};

const matFormFieldDefaultOptions: MatFormFieldDefaultOptions = {
  subscriptSizing: 'dynamic',
  floatLabel: 'auto'
};

@NgModule({
  declarations: [
    AppComponent,
    UpgradeComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    DisableAutocompleteDirectiveModule,
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      enableHtml: true,
      preventDuplicates: true,
    }),
    AppRoutingModule,
    SharedModule,
    CoreModule,
    InfiniteScrollModule,
    ClipboardModule,
    JoyrideModule.forRoot(),
    SettingsModule,
    MatSidenavModule,
    SidepanelModule,
    MatSelectModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    NewSidenavModule,
  ],
  providers: [
    {
      provide: MAT_LIST_CONFIG,
      useValue: matListConfig,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: matFormFieldDefaultOptions,
    },
    {
      provide: MAT_SELECT_CONFIG,
      useValue: matSelectConfig,
    },
    {
      provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
      useValue: matButtonToggleDefaultOptions,
    },
    {
      provide: MAT_SLIDE_TOGGLE_DEFAULT_OPTIONS,
      useValue: matSlideToggleDefaultOptions,
    },
    {
      provide: MAT_CHIPS_DEFAULT_OPTIONS,
      useValue: {
        separatorKeyCodes: [ENTER, COMMA],
      },
    },
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: customTooltipDefaults,
    },
    {
      provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,
      useValue: spinnerDefaults,
    },
    {
      provide: MAT_PROGRESS_BAR_DEFAULT_OPTIONS,
      useValue: progressBarDefaults,
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: dialogDefaultOptions,
    },
    {
      provide: MAT_TABS_CONFIG,
      useValue: tabsDefaults,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
}
